'use client'

import { useEffect, useState } from 'react'
import { fetchProductByIdApi } from '@/lib/commerce/services/product-api'

export function useProductsByIds(vendorId: string, productIds: string[]) {
  const [products, setProducts] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const key = productIds.join(',')

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      if (!vendorId || productIds.length === 0) {
        setProducts([])
        setIsLoading(false)
        return
      }
      setIsLoading(true)
      try {
        const results = await Promise.all(productIds.map(id => fetchProductByIdApi(vendorId, id)))
        if (cancelled) return
        setProducts(results.filter(r => r?.status === 200 && r.data).map(r => r.data))
      } catch (err) {
        console.error('Error fetching products:', err)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    run()
    return () => { cancelled = true }
  }, [vendorId, key])

  return { products, isLoading }
}
